import { CommonModule } from '@angular/common';
import { Component, ElementRef, HostListener, inject, ViewChild } from '@angular/core';
import { TranslateModule, TranslateService } from '@ngx-translate/core';
import { LanguageService } from '../../services/language.service';

@Component({
  selector: 'app-language-selector',
  standalone: true,
  imports: [
    TranslateModule,
    CommonModule,
  ],
  templateUrl: './language-selector.component.html',
  styleUrl: './language-selector.component.scss'
})
export class LanguageSelectorComponent {
  private readonly translate = inject(TranslateService);
  private readonly elementRef = inject(ElementRef);
  private readonly languageService = inject(LanguageService)
  @ViewChild('logoContainer') logoContainer!: ElementRef;

  showLanguages = false;
  language = this.languageService.getLanguage();


  @HostListener('document:click', ['$event'])
  handleClickOutside(event: Event): void {
    if (!this.elementRef.nativeElement.contains(event.target)) {
      this.showLanguages = false;
    }
  }

  changeLanguage(language: string) {
    this.translate.use(language);
    this.languageService.setLanguage(language);
    this.showLanguages = false;
  }

  handleClickTogglenOptions() {
    this.showLanguages = !this.showLanguages;
  }

  get currentLang(): string {
    return  this.translate.currentLang;
  }
}
